import { createApp } from "vue";
import ActivityMap from "./ActivityMap.vue";
import { createPinia, setActivePinia } from "pinia";
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";

const pinia = createPinia();

setActivePinia(pinia)

const app = createApp(ActivityMap);
app.use(pinia);
app.use(Notifications, { velocity });

app.mount("#activity-map");
